import { render, staticRenderFns } from "./StudyDatasetSummary.vue?vue&type=template&id=0fa57fae&scoped=true"
import script from "./StudyDatasetSummary.vue?vue&type=script&lang=js"
export * from "./StudyDatasetSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa57fae",
  null
  
)

export default component.exports